import { render, staticRenderFns } from "./CodingAdd.vue?vue&type=template&id=1c8caabc&scoped=true"
import script from "./CodingAdd.vue?vue&type=script&lang=js"
export * from "./CodingAdd.vue?vue&type=script&lang=js"
import style0 from "./CodingAdd.vue?vue&type=style&index=0&id=1c8caabc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8caabc",
  null
  
)

export default component.exports